// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__BqMZk","errorLogs":"styles_errorLogs__21YjK"};